import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';
import { PutConsentsRequest } from 'models/swagger/MarketingConsent/PutConsentsRequest';

export const api = {
  putConsents: (url: string, request: PutConsentsRequest): Promise<ExtendedAxiosResponse> =>
    apiClient.put(
      `${url}/consents`,
      {
        partyType: request.partyType || CustomerMasterSourceType.O2POP,
        partyIdentifierType: 'customerId',
        partyIdentifierValue: request.cuRefNo,
        consent: {
          consentType: 'A',
          transactionDate: request.date,
          userIdentification: request.userIdentification,
          messageVersion: request.messageVersion,
          consentChannel: ChannelType.MO2_CARE,
        },
      },
      {
        params: {
          channel: ChannelType.MO2_CARE,
        },
      }
    ),

  getConsents: (url: string, cuRefNo: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/consents`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        partyType: 'O2POPD',
        partyIdentifierType: 'customerId',
        partyIdentifierValue: cuRefNo,
      },
    }),
};
